export const chapterTemplates = {
  rochester: {
    id: 'rochester',
    name: 'University of Rochester',
    campus: 'Rochester, New York',
    established: 'Established 2022',
    status: 'active',
    // focus: 'Project Level the Field Headquarters',
    link: '/rochester',
    image: '/images/chapterimg/rochester.webp'
  },
  cornell: {
    id: 'cornell',
    name: 'Cornell University',
    campus: 'Ithaca, New York',
    established: 'Established 2024',
    status: 'active',
    // focus: 'STEM-focused mentorship and partnerships with rural high schools.',
    link: '/cornell',
    image: '/images/chapterimg/cornell.webp'
  },
  uchicago: {
    id: 'uchicago',
    name: 'University of Chicago',
    campus: 'Chicago, Illinois',
    established: 'Established 2024',
    status: 'active',
    // focus: 'Essay studios and financial-aid workshops led by interdisciplinary mentors.',
    link: '/uchicago',
    image: '/images/chapterimg/uchicago.webp'
  },
  jhu: {
    id: 'jhu',
    name: 'Johns Hopkins University',
    campus: 'Baltimore, Maryland',
    established: 'Launching soon',
    status: 'coming-soon',
    // focus: 'Building a medical humanities cohort with local school partners.',
    link: '/jhu',
    image: '/images/chapterimg/jhu.webp'
  },
  princeton: {
    id: 'princeton',
    name: 'Princeton University',
    campus: 'Princeton, New Jersey',
    established: 'Launching soon',
    status: 'coming-soon',
    // focus: 'Interdisciplinary mentorship with special focus on civic leadership.',
    link: '/princeton',
    image: '/images/chapterimg/princeton.webp'
  },
  columbia: {
    id: 'columbia',
    name: 'Columbia University',
    campus: 'New York City, New York',
    established: 'Launching soon',
    status: 'coming-soon',
    // focus: 'Story-driven admissions prep piloted with NYC public schools.',
    link: '/columbia',
    image: '/images/chapterimg/columbia.webp'
  },
  upenn: {
    id: 'upenn',
    name: 'University of Pennsylvania',
    campus: 'Philadelphia, Pennsylvania',
    established: 'Launching soon',
    status: 'coming-soon',
    // focus: 'Cross-cohort mentorship weaving business, design, and policy.',
    link: '/upenn',
    image: '/images/chapterimg/upenn.webp'
  },
  tufts: {
    id: 'tufts',
    name: 'Tufts University',
    campus: 'Medford, Massachusetts',
    established: 'Launching soon',
    status: 'coming-soon',
    // focus: 'Community-first programming with Greater Boston partners.',
    link: '/tufts',
    image: '/images/chapterimg/tufts.webp'
  },
  usf: {
    id: 'usf',
    name: 'University of South Florida',
    campus: 'Tampa, Florida',
    established: 'Launching soon',
    status: 'coming-soon',
    // focus: 'Latinx mentorship collective focused on first-generation students.',
    link: '/usf',
    image: '/images/chapterimg/usf.webp'
  }
};

export const chapterList = Object.values(chapterTemplates);
